<template>
  <div class="w-10/12 mx-auto flex-row flex-wrap justify-between font-costea">

    <div class="flex flex-row justify-between pt-3 pb-2 mb-6 mt-2 border-b-2 flex-wrap">
      <h1 class="font-costea text-h24 font-medium text-costeaBlack">
        Gastos de Administración
      </h1>
      <div class="flex flex-row items-center">
        <div v-if="gastos.length > 0" class="flex bg-white p-2 mr-2 rounded-md costeaBlueGradient">
          <p class="text-white mr-2 ml-2">{{ `COP $ ${interNumberFormat(calcTotalCost)}` }}</p>
        </div>

        <div class="flex flex-row justify-center items-center mx-2">
          <select v-model="filtroOrden" class="text-costeaGray px-2 py-1 rounded-md mx-2 text-base text-t14 h-10">
            <option value="0">Ordenar por:</option>
            <option value="1">Menor a mayor</option>
            <option value="2">Mayor a menor</option>
          </select>
        </div>

        <p class="text-costeaGray ml-6 mr-3 text-t14">
          <span class="text-costeaBlack font-medium">{{ page }}</span> de <span>{{ getPageNumber() }}</span>
        </p>
        <div class="flex flex-row h-full">
          <button class="w-10 mr-1 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray opacity-50" @click="page--, getPageNumber()" v-if="page != 1">
            <i class="ri-arrow-left-line"></i>
          </button>
          <button class="w-10 bg-costeaBtn2 hover:bg-costeaBtn2Hover text-costeaGray" @click="page++, getPageNumber()" v-show="page < getPageNumber()">
            <i class="ri-arrow-right-line"></i>
          </button>
        </div>
      </div>
    </div>

    <div class="grid grid-cols-12 gap-x-5">
      <div class="col-start-1 col-end-13 bg-white p-6 rounded-md">
        <thead class="h-10 flex flex-row items-center font-costea text-t14 border-b-2">
          <th class="text-costeaDarkGray w-4/12 px-2 text-left">Nombre del Gasto</th>
          <th class="text-costeaDarkGray w-4/12 px-2 text-left">Gasto</th>
        </thead>
        <tbody v-for="gasto in displayedGasto" :key="gasto.id"
          class="h-14 flex flex-row items-center font-costea text-t14 border-b-2 border-gray-100 hover:bg-costeaContainer">
          <td @click="showModalEdit(gasto.nombre_gasto, gasto.id, gasto.gasto_mensual)" class="hover:underline px-2 cursor-pointer text-costeaGray w-4/12">
            {{ gasto.nombre_gasto }}
          </td>
          <td @click="showModalEdit(gasto.nombre_gasto, gasto.id, gasto.gasto_mensual)" class="hover:underline px-2 cursor-pointer text-costeaGray w-4/12">
            $ {{ interNumberFormat(gasto.gasto_mensual) }}
          </td>
          <td class="flex ml-auto w-4/12 justify-end">
            <button @click="showModalDelete(gasto.nombre_gasto, gasto.id)" class="ml-2 mr-2 bg-gray-100 text-costeaGray hover:bg-costeaSalmonDisabled hover:text-costeaDarkSalmon h-6 w-6 rounded-full flex justify-center items-center">
              <i class="ri-delete-bin-6-line"></i>
            </button>
            <button @click="showModalEdit(gasto.nombre_gasto, gasto.id, gasto.gasto_mensual)" class="ml-2 mr-2 bg-gray-100 text-costeaGray hover:bg-costeaPrimaryDisabled hover:text-costeaPrimary h-6 w-6 rounded-full flex justify-center items-center">
              <i class="ri-edit-line"></i>
            </button>
          </td>
        </tbody>
      </div>
    </div>

    <!-- Modal de edición -->
    <transition name="page">
      <component :gastoOld="editGastoName" :idGasto="parseInt(editGastoId)" @closeModalEdit="handleEditGastoCloseModal" @reloadData="reloadData" v-show="modalEditActive" :is="editModal"/>
    </transition>

    <!-- Modal de eliminación -->
    <transition name="page">
      <component :gastoOld="deleteGastoName" :idGasto="parseInt(deleteGastoId)" @closeModalDelete="handleDeleteGastoCloseModal" @reloadData="reloadData" v-show="modalDeleteActive" :is="deleteModal"/>
    </transition>

    <!-- Modal de adición -->
    <transition name="page">
      <component @closeModalAdd="handleAddGastoCloseModal" @reloadData="reloadData" v-show="modalActive" :is="selected"/>
    </transition>

    <buttonAdd @showModal="handleShowGasto"/>
    
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import buttonAdd from '@/components/elements/ButtonAdd.vue'
import addGasto from '@/components/gastos/AddGasto.vue' 
import editGasto from '@/components/gastos/EditGasto.vue' 
import deleteGasto from '@/components/gastos/DeleteGasto.vue' 

export default {
  name: "gasto",
  components: {
    buttonAdd,
    addGasto,
    editGasto,
    deleteGasto
  },
  data() {
    return {
      gastos: [],
      page: 1,
      pages: [],
      elementsPerPage: 8,
      modalActive: false,
      selected: 'addGasto',
      editGastoName: '',
      editGastoId: 0,
      deleteGastoName: '',
      deleteGastoId: 0,
      modalEditActive: false,
      modalDeleteActive: false,
      filtroOrden: '0'
    }
  },
  computed: {
    ...mapState(['costea']),
    calcTotalCost() {
      let total = 0;
      this.gastos.forEach(element => {
        total += Number(element.gasto_mensual);
      });
      return total.toFixed(2);
    },
    displayedGasto() {
      if (this.filtroOrden == "") {
        return this.paginate(this.gastos)
      } else {
        return this.paginate(this.ordenar)
      }
    },
    editModal() {
      return this.modalEditActive ? 'editGasto' : ''
    },
    deleteModal() {
      return this.modalDeleteActive ? 'deleteGasto' : ''
    },
    ordenar() {
      let data = [...this.gastos]; // Clonamos el arreglo para no modificar el original
      if (this.filtroOrden == '0') {
        data.sort((a, b) => a.id - b.id)
      }
      if (this.filtroOrden == '1') {
        data.sort((a, b) => a.gasto_mensual - b.gasto_mensual)
      }
      if (this.filtroOrden == '2') {
        data.sort((a, b) => b.gasto_mensual - a.gasto_mensual)
      }
      return data;
    },
  },
  methods: {
    interNumberFormat(number) {
      let interNF = new Intl.NumberFormat('es-CO');
      let numberDecimals = parseFloat(number);
      numberDecimals = numberDecimals.toFixed(2);
      return interNF.format(numberDecimals);
    },
    handleShowGasto(value) {
      this.modalActive = value;
    },
    handleAddGastoCloseModal(value) {
      this.modalActive = value;
    },
    handleEditGastoCloseModal(value) {
      this.modalEditActive = value;
    },
    handleDeleteGastoCloseModal(value) {
      this.modalDeleteActive = value;
    },
    showModalEdit(gastoNombre, gastoId) {
      if (!this.modalEditActive) {
        this.modalEditActive = true;
        this.editGastoName = gastoNombre;
        this.editGastoId = parseInt(gastoId);
      } else {
        this.modalEditActive = false;
      }
    },
    showModalDelete(gastoNombre, gastoId) {
      if (!this.modalDeleteActive) {
        this.modalDeleteActive = true;
        this.deleteGastoName = gastoNombre;
        this.deleteGastoId = parseInt(gastoId);
      } else {
        this.modalDeleteActive = false;
      }
    },
    getGastos() {
      axios.get(`${this.costea.protocol}${localStorage.getItem('secret-word')}${this.costea.baseURL}gastos`)
        .then(response => {
          if (response.data.status === false) {
            this.$router.push('/login')
          }
          this.gastos = response.data;
          console.log(this.gastos)
          this.pages = [];
          this.setPages();
        }).catch((error) => {
          if (error && error.status === 401) {
            this.$router.push('/login')
          }
        });
    },
    reloadData(value) {
      if (value === true) {
        this.getGastos();
      } else {
        console.log('Ocurrió un error')
      }
    },
    setPages() {
      let numberOfPages = Math.ceil(this.gastos.length / this.elementsPerPage);
      this.pages = [];
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index);
      }
    },
    paginate(data) {
      let page = this.page;
      let perPage = this.elementsPerPage;
      let from = (page * perPage) - perPage;
      let to = (page * perPage);
      return data.slice(from, to);
    },
    getPageNumber() {
      return this.pages.length;
    }
  },
  beforeMount() {
    if (localStorage.getItem('token')) {
      this.getGastos();
    } else {
      this.$router.push('/login');
    }
  },
}
</script>

<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .3s;
}
</style>
